var React = require('react');

function CertifiedGoals (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"certifiedGoals"),React.createElement("g",{"id":"certifiedGoals","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round","key":1},React.createElement("g",{"id":"target","transform":"translate(1.000000, 1.000000)","stroke":"#014752","strokeWidth":"1.60077201"},[React.createElement("circle",{"id":"Oval","cx":"12","cy":"12","r":"7.2","key":0}),React.createElement("circle",{"id":"Oval","cx":"12","cy":"12","r":"12","key":1}),React.createElement("circle",{"id":"Oval","cx":"12","cy":"12","r":"2.4","key":2})]))]);
}

CertifiedGoals.defaultProps = {"width":"25px","height":"25px","viewBox":"0 0 25 25","version":"1.1"};

module.exports = CertifiedGoals;

CertifiedGoals.default = CertifiedGoals;
